import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Versioning for the Primer presentation system will be logged by date. All updates will be kept in a changelog located in both the presenters notes of a changelog slide and on the Primer presentations site.`}</p>
    <h2>{`Changelog`}</h2>
    <h3>{`October 23, 2019`}</h3>
    <p>{`Figma:`}</p>
    <ul>
      <li parentName="ul">{`Added instructions`}</li>
      <li parentName="ul">{`Removed extraneous slides & components`}</li>
      <li parentName="ul">{`Simplified global variables in components`}</li>
    </ul>
    <h3>{`July 16, 2019`}</h3>
    <p>{`Keynote:`}</p>
    <ul>
      <li parentName="ul">{`Removed extraneous slides (Title & Subtitle, Title Left)`}</li>
      <li parentName="ul">{`Added slides - Title Slide - White - Title - Bottom Light`}</li>
      <li parentName="ul">{`Added more spacing for bullet and body paragraph text`}</li>
      <li parentName="ul">{`Mapped any free form text to text styles`}</li>
      <li parentName="ul">{`Included icons directory in main download`}</li>
    </ul>
    <h3>{`May 15, 2019`}</h3>
    <ul>
      <li parentName="ul">{`Added icon set thumbnails and format icons to docs for clearer context`}</li>
    </ul>
    <p>{`Keynote:`}</p>
    <ul>
      <li parentName="ul">{`Fixed `}<inlineCode parentName="li">{`Missing font...`}</inlineCode>{` bug.`}</li>
    </ul>
    <h3>{`May 1, 2019`}</h3>
    <ul>
      <li parentName="ul">{`Microsoft Office users rejoice! The presentation design system now includes source files for PowerPoint. Inside you will now find the following:`}
        <ul parentName="li">
          <li parentName="ul">{`PowerPoint theme (.thmx)`}</li>
          <li parentName="ul">{`PowerPoint template (.potx)`}</li>
          <li parentName="ul">{`PowerPoint file (.pptx)`}</li>
          <li parentName="ul">{`GitHub Icons for PowerPoint`}</li>
          <li parentName="ul">{`Logo sheet for PowerPoint`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Separated keynote, powerpoint, and icon files into separate .zip files`}</li>
      <li parentName="ul">{`Added documentation for powerpoint and updated asset links to reflect changes`}</li>
    </ul>
    <p>{`Keynote:`}</p>
    <ul>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`Section Title - Blue`}</inlineCode>{` layout`}</li>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`Browser`}</inlineCode>{` layout`}</li>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`Body Bullets White`}</inlineCode>{` text style`}</li>
      <li parentName="ul">{`Updated slide master name from "Section Title - Hubot" to "Section Title - Yellow"`}</li>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`Title`}</inlineCode>{` slide decorative images`}</li>
      <li parentName="ul">{`Fixed top titles position to `}<inlineCode parentName="li">{`y:80px`}</inlineCode></li>
      <li parentName="ul">{`Fixed bullet level indentation`}</li>
    </ul>
    <p>{`Google Slides:`}</p>
    <ul>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`Section Title - Blue`}</inlineCode>{` layout`}</li>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`Browser`}</inlineCode>{` layout`}</li>
    </ul>
    <p>{`Figma:`}</p>
    <ul>
      <li parentName="ul">{`Better organization of slide layouts`}</li>
      <li parentName="ul">{`Created bullet and title text components`}</li>
    </ul>
    <h3>{`April 17, 2019`}</h3>
    <ul>
      <li parentName="ul">{`First release!`}</li>
      <li parentName="ul">{`We've included Keynote, Google Slides, and Figma presentation formats`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      